export default __webpack_public_path__ + "assets/logo-sprite.4782679a9c2f7f4bf5a73183ef7fa6d1.svg";